import css from './styles.module.scss'
import ComparatorsCard from '../ComparatorsCard'

const ComparatorsGrid = ({ comparators }) => {
  return (
    <div className={css.container}>
      {comparators.map((comparator) => {
        return <ComparatorsCard key={comparator?.id} {...comparator} />
      })}
    </div>
  )
}

export default ComparatorsGrid
